/**
 *    @author:
 *    @since:
 *
 */

import { Component} from '@angular/core';
import { Router } from '@angular/router';

@Component({ 
      selector: 'error',
      templateUrl: './error.component.html',
      styleUrls: ['./error.component.less']
})
export class ErrorComponent {


      constructor( public router: Router) {

      }

      public ngOnInit() {
      }
}
